import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { Divider } from '@bufferapp/components';
import { Button, Tooltip } from '@bufferapp/ui';
import AddChannelButton from '../AddChannelButton';
import {
  ManageSocialAccountsStyle,
  SocialButtonsWrapperStyle,
  ButtonDividerStyle,
  BottomSectionStyle,
} from './style';

const ConditionalWrapper = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children;

const ManageSocialAccounts = ({
  canManageSocialAccounts,
  reachedChannelLimit,
  manageChannelsURL,
  ownerEmail,
  hasProfiles,
  showAddChannels,
  showManageChannels,
}) => {
  const { t } = useTranslation();

  return (
    <ManageSocialAccountsStyle>
      <SocialButtonsWrapperStyle>
        {canManageSocialAccounts && showAddChannels && (
          <AddChannelButton
            reachedChannelLimit={reachedChannelLimit}
            label={t('profile-sidebar.addChannels')}
          />
        )}
        {showManageChannels && (
          <BottomSectionStyle>
            <ButtonDividerStyle>
              <Divider color="grayLight" marginTop="1rem" />
            </ButtonDividerStyle>
            <ConditionalWrapper
              condition={!canManageSocialAccounts}
              wrapper={(children) => (
                <Tooltip
                  label={t('profile-sidebar.permissionSubtitle', {
                    email: ownerEmail,
                  })}
                  position="top"
                >
                  {children}
                </Tooltip>
              )}
            >
              <Button
                label={t(
                  `profile-sidebar.${
                    hasProfiles ? 'connectButton' : 'addChannels'
                  }`
                )}
                type="secondary"
                fullWidth
                disabled={!canManageSocialAccounts}
                onClick={() => {
                  window.location.assign(manageChannelsURL);
                }}
              />
            </ConditionalWrapper>
          </BottomSectionStyle>
        )}
      </SocialButtonsWrapperStyle>
    </ManageSocialAccountsStyle>
  );
};

ManageSocialAccounts.propTypes = {
  canManageSocialAccounts: PropTypes.bool,
  reachedChannelLimit: PropTypes.bool,
  manageChannelsURL: PropTypes.string.isRequired,
  ownerEmail: PropTypes.string,
  hasProfiles: PropTypes.bool.isRequired,
  showAddChannels: PropTypes.bool.isRequired,
  showManageChannels: PropTypes.bool.isRequired,
};

ManageSocialAccounts.defaultProps = {
  canManageSocialAccounts: true,
  reachedChannelLimit: false,
  ownerEmail: 'the owner',
};

export default ManageSocialAccounts;
